export const environment = {
  production: false,
  apiUrl: 'https://back.devcorehub.com/api/v1',
  serverUrl: 'https://back.devcorehub.com',
  enableDebug: true
};
